// App-shell banner for the org_admin: persistent while the org's own
// subscription is suspended or past_due. Only org_admin can read
// GET /billing/subscription (the endpoint is org_admin-only), so the query is
// disabled for every other role — including super_admin on platform views.
//
// The endpoint runs behind SubscriptionAccessGuard, which lazily persists a
// past_due -> suspended transition once grace elapses, so the status returned
// here is already the effective one. The query is the shared
// `useOwnSubscription` one (same key as the Subscription page and the
// dashboard card): hiding the banner on the Subscription page does not
// create a second request.

import { useLocation } from '@tanstack/react-router';

import { useOwnSubscription } from '../hooks/useOwnSubscription';
import { isNoticeStatus, SubscriptionStatusNotice } from './SubscriptionStatusNotice';

const SUBSCRIPTION_PATH = '/dashboard/settings/subscription';

export function SubscriptionStatusBanner({ userRole }: { userRole: string }) {
  const pathname = useLocation({ select: (l) => l.pathname });
  const enabled = userRole === 'org_admin';
  const { data } = useOwnSubscription({ enabled });

  if (!enabled || !data || !isNoticeStatus(data.status)) return null;
  // The Subscription page renders the same notice inline; don't stack two.
  if (pathname.startsWith(SUBSCRIPTION_PATH)) return null;

  return (
    <div className="mb-6">
      <SubscriptionStatusNotice
        status={data.status}
        graceUntil={data.graceUntil}
        collectionMethod={data.collectionMethod}
        showLink
      />
    </div>
  );
}
